import React, { useState, useEffect, useCallback, createRef, useMemo, useRef } from 'react'
import { useCMSContext } from './../../CMSContext'
import WelcomeActions from './WelcomeActions'
// Material-UI
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import { IARRte } from '../../../Shared/iar-rte'
import Button from '@mui/material/Button'
import './App.css'
import './WelcomeMessage.scss'
import { FaRegCheckCircle } from 'react-icons/fa'
import ChooseImage from '../../../Shared/ChooseImage'
import ChooseVideo from '../../../Shared/ChooseVideo'
import CustomDropdown from '../../../Shared/Dropdown/dropdown'
import LoadingSpinner from '../../../Shared/LoadingSpinner/LoadingSpinner'
import ButtonSave from '../../../Shared/ButtonSave/ButtonSave'
import MediaThumbnail from '../../../Shared/MediaThumbnail/MediaThumbnail'
import CommunityTextField from '../../../Shared/CommunityTextField'
import MediaFilesMessage from '../../../Shared/MediaFilesMessage'
import OnlineVideos from '../../../Shared/OnlineVideos'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'
import { videoTypes } from '../../../../Constants/videoTypes'
import { IARDialog } from '../../../Shared/Dialog/IARDialog'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import CMSActions from '../../CMSActions'
import { EncondingSectionType } from 'app/Constants/EncodingSectionType'
import { CustomSwitch } from 'app/Components/Shared/Switch/switch'
import PrepublishButtons from 'app/Components/Shared/PrepublishButtons/PrepublishButtons'
import { EmptyTagsTypes } from 'app/Constants/bodyTextValidationsTypes'
import { cloneDeep } from 'lodash'
import PreviewContentLabel from 'app/Components/Shared/PreviewContentLabel/PreviewContentLabel'

function WelcomeMessage({ anotherMessage }) {
  const wrapper = createRef()
  const { errorSnackBarActions } = useErrorSnackBarContext()
  Interceptor.interceptor(errorSnackBarActions)
  const INITIAL_STATE = {
    bodyText: '',
    title: '',
    positionFiles: 0,
    postMessage: '',
    sectionActive: true,
    fireDepartmentIdentifier: '',
    images: [],
    videos: [],
    onlineVideos: []
  }
  const cmsContext = useCMSContext()
  const {
    fireDepartment,
    socket,
    iarMember,
    appConfiguration,
    isReadOnlyMember,
    newVideoEncoding
  } = cmsContext.state
  const [welcomeMessageEntity, setWelcomeEntity] = useState(INITIAL_STATE)
  const [welcomeMessageDiscardEntity, setWelcomeDiscardEntity] = useState(INITIAL_STATE)
  const [images, setImages] = useState([]) // this images is the one to be send in post
  const [dataPosted, setDataPosted] = useState({ posted: false, message: '' })
  const [videos, setVideos] = useState([]) // this images is the one to be send in post
  const [onlineVideos, setOnlineVideos] = useState([])
  const [loading, setLoading] = useState(true)
  const [posting, setPosting] = useState(false)
  const [deletedFiles, setDeletedFiles] = useState([])
  const [tempUpdatedFiles, setTempUpdatedFiles] = useState([])
  const [errorLabel, setErrorLabel] = useState('')
  const [errorBodyText, setErrorBodyText] = useState('')
  const [disabledButton, setDisabledButton] = useState(true) //used for readonly mode
  const [errorTitle, setErrorTitle] = useState('')
  const [isDiscarded, setDiscarded] = useState(false)
  const [dialog, setDialog] = useState({ open: false })
  const [deletedSeconds, setDeletedSeconds] = useState([])
  const [isDiscardedMedia, setIsDiscardedMedia] = useState(false)
  const [bodyText, setBodyText] = useState('')

  useEffect(() => {
    setBodyText(welcomeMessageEntity.bodyText || '')
  }, [welcomeMessageEntity._id, welcomeMessageEntity.bodyText])

  //Properties for preview
  const [showPublishedContent, setShowPublishedContent] = useState(true)
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false)
  const [isDiscardDialogOpen, setIsDiscardDialogOpen] = useState(false)
  const [isPreviewDialogOpen, setIsPreviewDialogOpen] = useState(false)
  const [isPreviewNotSaveDialogOpen, setIsPreviewNotSavedDialogOpen] = useState(false)

  const previewedContentRef = useRef(INITIAL_STATE)
  const publishedContentRef = useRef(INITIAL_STATE)
  const previewDiscardContentRef = useRef(INITIAL_STATE)

  /* using namespace */
  const withNewEncodingProcess = useMemo(() => {
    return (
      newVideoEncoding &&
      videos &&
      videos?.some(
        (x) => !welcomeMessageDiscardEntity.videos.some((v) => v.fileName === x.fileName)
      )
    )
  }, [newVideoEncoding, videos, welcomeMessageDiscardEntity.videos])

  const getWelcomeMessageContent = async () => {
    let previewed = INITIAL_STATE
    const published =
      (await WelcomeActions.getWelcomeMessage(fireDepartment.identifier)) || INITIAL_STATE
    if (appConfiguration.previewEnabled) {
      previewed =
        (await WelcomeActions.getWelcomeMessagePreview(fireDepartment.identifier)) || INITIAL_STATE
    }
    let entity = showPublishedContent ? published : previewed
    if (entity) {
      setWelcomeEntity(entity)
      setWelcomeDiscardEntity(cloneDeep(entity))
      setImages(entity.images)
      setVideos(entity.videos)
      setOnlineVideos(entity.onlineVideos)
    }
    setLoading(false)
    return { previewed, published }
  }

  useEffect(() => {
    ;(async function () {
      if (fireDepartment?.identifier) {
        const { previewed, published } = await getWelcomeMessageContent()
        previewedContentRef.current = previewed
        publishedContentRef.current = published
        previewDiscardContentRef.current = cloneDeep(previewed)
        if (!appConfiguration.previewEnabled) setDisabledButton(false)
      } else {
        setLoading(false)
      }
    })()
  }, [appConfiguration.previewEnabled, fireDepartment?.identifier])

  useEffect(() => {
    if (!showPublishedContent && appConfiguration.previewEnabled) {
      setWelcomeEntity(previewedContentRef.current)
      setWelcomeDiscardEntity(cloneDeep(previewDiscardContentRef.current))
      setImages(previewedContentRef.current.images)
      setVideos(previewedContentRef.current.videos)
      setOnlineVideos(previewedContentRef.current.onlineVideos)
    } else {
      setWelcomeEntity(publishedContentRef.current)
      setWelcomeDiscardEntity(cloneDeep(publishedContentRef.current))
      setImages(publishedContentRef.current.images)
      setVideos(publishedContentRef.current.videos)
      setOnlineVideos(publishedContentRef.current.onlineVideos)
    }
  }, [appConfiguration.previewEnabled, showPublishedContent])

  useEffect(() => {
    if (fireDepartment && socket) {
      socket.on(`${fireDepartment.fireDepartmentId.toString()}_inner_welcome_message`, (args) => {
        console.log('CMS_inner_welcome_message', args, new Date())
        if (args.action === 'start') {
          setDisabledButton(true)
        }
        if (args.action === 'error') {
          setDisabledButton(false)
        }
        if (args.action === 'saved') {
          setDataPosted({ posted: true, message: 'Saved' })
          setPosting(false)

          //if Publish is turn on, keep disabled
          if (Boolean(args.isPreview)) setDisabledButton(showPublishedContent)
          else setDisabledButton(false)

          if (args.memberId === iarMember.memberId) {
            if (args.response) {
              previewDiscardContentRef.current = cloneDeep(args.response)

              if (!appConfiguration.previewEnabled) publishedContentRef.current = args.response
              else {
                previewedContentRef.current = args.response
                if (showPublishedContent) return
              }

              //just apply when you are presenting preview
              setWelcomeEntity(args.response)
              setWelcomeDiscardEntity(cloneDeep(args.response))
              setImages(args.response.images)
              setVideos(args.response.videos)
              setOnlineVideos(args.response.onlineVideos)
            }
          }
        }
      })
    }
    return () => {
      socket.off(`${fireDepartment.fireDepartmentId.toString()}_inner_welcome_message`)
    }
  }, [
    disabledButton,
    fireDepartment,
    socket,
    showPublishedContent,
    iarMember.memberId,
    appConfiguration.previewEnabled
  ])

  const publishPost = async () => {
    setIsSaveDialogOpen(false)
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)
    setDisabledButton(true)
    WelcomeActions.postPublishWelcomeMessage(welcomeMessageEntity?.fireDepartmentIdentifier).then(
      (data) => {
        publishedContentRef.current = data
        previewDiscardContentRef.current = cloneDeep(data)
        previewedContentRef.current = data
        setWelcomeEntity(data)
        setWelcomeDiscardEntity(cloneDeep(data))
        setImages(data?.images ?? [])
        setVideos(data?.videos ?? [])
        setOnlineVideos(data?.onlineVideos ?? [])
        setDataPosted({ posted: true, message: 'Saved' })
        setDeletedSeconds([])
        setDeletedFiles([])
        console.log(`POST puiblish preview for welcome message section Response: ${data}`)
        setPosting(false)
        setDisabledButton(false)
      },
      (err) => {
        setErrorLabel('There was an error Publishing welcome message section')
        errorSnackBarActions.setOpen(true, errorLabel)
        setPosting(false)
        setDisabledButton(false)
      }
    )
  }

  useEffect(() => {
    if (errorLabel !== '') {
      errorSnackBarActions.setOpen(true, errorLabel)
    }
  }, [errorLabel])

  const handleChange = useCallback((evt) => {
    const value = evt.target.value
    setWelcomeEntity((welcomeMessageEntity) => ({
      ...welcomeMessageEntity,
      [evt.target.name]: value
    }))
  }, [])

  const rteChangeHandler = (content) => {
    setBodyText(content.trim())
  }

  const renderSavedMessage = () => {
    if (dataPosted.posted) {
      return (
        <div className="save-message">
          <FaRegCheckCircle className="check-circle" />
          <span className="save-message-text">{dataPosted.message}</span>
        </div>
      )
    }
  }

  const onLineVideoPayloadArray = () => {
    return (
      onlineVideos?.map((v) => ({
        fireDepartmentIdentifier: fireDepartment.identifier,
        originalName: v.originalName,
        caption: v.caption,
        fileName: `${v.url}_${Date.now().toString()}`,
        type: 'online',
        provider: v.provider,
        url: v.url,
        fileSize: '',
        binary: v.binary
      })) ?? []
    )
  }

  const videoPayloadArray = () => {
    let videoPayload = []
    if (welcomeMessageEntity.videos) {
      videos.forEach((video) => {
        if (video.binary) {
          videoPayload.push({
            originalName: video.FileName,
            caption: video.caption,
            type: video.type,
            fileSize: video.fileSize,
            binary: video.binary,
            secondsDuration: video.secondsDuration
          })
        }
      })
    } else {
      videoPayload = videos
    }

    return videoPayload
  }

  const imagePayloadArray = () => {
    let imagesPayload = []
    if (welcomeMessageEntity.images) {
      images.forEach((image) => {
        let fileExists = !welcomeMessageEntity.images.some((i) => {
          return i.fileName === image.fileName
        })

        if (fileExists) {
          imagesPayload.push({
            file: image.file,
            originalName: image.originalName,
            caption: image.caption,
            fileSize: image.fileSize,
            type: image.type
          })
        }
      })
    } else {
      imagesPayload = images
    }
    return imagesPayload
  }

  const successPost = useCallback((response) => {
    setWelcomeEntity(response.data)
    setWelcomeDiscardEntity(response.data)
    previewedContentRef.current = response.data
    previewDiscardContentRef.current = cloneDeep(response.data)

    if (response.data.images.length > 0) {
      setImages(response.data.images)
    }
    if (response.data.videos.length > 0) {
      setVideos(response.data.videos)
    }
    if (response.data.onlineVideos.length > 0) {
      setOnlineVideos(response.data.onlineVideos)
    }
    setDataPosted({ posted: true, message: 'Saved' })
    setPosting(false)
    setDeletedSeconds([])
    setDeletedFiles([])
    closePreviewDialog()
  }, [])

  const setDataPayload = (img, vid, online) => {
    const data = {
      _id: welcomeMessageEntity._id || '',
      fireDepartmentIdentifier: fireDepartment.identifier,
      title: welcomeMessageEntity.title,
      bodyText: bodyText,
      images: img,
      videos: vid,
      onlineVideos: online,
      positionFiles: parseInt(welcomeMessageEntity.positionFiles),
      filesToDelete: deletedFiles,
      filesToUpdate: tempUpdatedFiles,
      deletedSeconds: deletedSeconds
    }

    if (!welcomeMessageEntity._id) {
      delete data._id
    }

    const formData = new FormData()

    formData.append('request', JSON.stringify(data))

    videos.forEach((video) => {
      if (video.binary === undefined) return

      formData.append('videos', video.binary, video.originalName)

      video.binary = null
    })

    images.forEach((image) => {
      if (image.file === undefined) return

      formData.append('images', image.file, image.originalName)
      image.file = null
    })

    return formData
  }

  const setNewEncodingPayload = (img, number_video, online, type) => {
    const data = {
      title: welcomeMessageEntity.title,
      richText: bodyText,
      videosNumber: number_video,
      videos: [],
      images: img,
      onlineVideos: online,
      type: type,
      contentId: welcomeMessageEntity._id,
      positionFiles: parseInt(welcomeMessageEntity.positionFiles),
      identifier: fireDepartment.identifier,
      fireDepartmentId: fireDepartment.fireDepartmentId,
      socketChannels: [
        `${fireDepartment.fireDepartmentId.toString()}_inner_welcome_message`,
        `${fireDepartment.fireDepartmentId.toString()}_welcome_message`
      ],
      deletedFiles,
      updatedFiles: tempUpdatedFiles,
      deletedSeconds: deletedSeconds,
      memberId: iarMember.memberId,
      sendPushNotifications: false
    }

    const formData = new FormData()

    formData.append('request', JSON.stringify(data))

    images.forEach((image) => {
      if (image.file === undefined) return

      formData.append('images', image.file, image.originalName)
      image.file = null
    })

    return formData
  }

  const sendWelcomeMessage = async () => {
    setDataPosted({ ...dataPosted, posted: false })

    let readyToSave = isReadyToSave()
    if (!readyToSave) {
      setErrorLabel('Missing Information')
      errorSnackBarActions.setOpen(true, errorLabel)
      setDataPosted({ posted: false, message: 'Missing Information' })
      return
    }
    setPosting(true)
    let online = onLineVideoPayloadArray()
    let vid = videoPayloadArray()
    let img = imagePayloadArray()

    const jsonData = setDataPayload(img, vid, online)

    if (readyToSave) {
      await WelcomeActions.getWelcomeMessageEmitStart(fireDepartment)
      const response = await WelcomeActions.postWelcomeMessage(iarMember, jsonData)
      if (response !== 'error') {
        successPost(response)
        console.log('POST WelcomeMessage: ', response)
      } else {
        errorSnackBarActions.setOpen(true)
        setPosting(false)
      }
    }
  }

  const sendWelcomeMessagePreview = async () => {
    setDataPosted({ ...dataPosted, posted: false })
    closePreviewDialog()
    let readyToSave = isReadyToSave()
    if (!readyToSave) {
      setErrorLabel('Missing Information')
      errorSnackBarActions.setOpen(true, errorLabel)
      setDataPosted({ posted: false, message: 'Missing Information' })
      return
    }

    setPosting(true)
    let online = onLineVideoPayloadArray()
    let vid = videoPayloadArray()
    let img = imagePayloadArray()

    const jsonData = setDataPayload(img, vid, online)

    if (readyToSave) {
      await WelcomeActions.getWelcomeMessageEmitStart(fireDepartment)
      const response = await WelcomeActions.postWelcomeMessagePreview(iarMember, jsonData)
      if (response !== 'error') {
        successPost(response)
        console.log('POST WelcomeMessage: ', response)
      } else {
        errorSnackBarActions.setOpen(true)
        setPosting(false)
      }
    }
  }

  const removeOnlineVideo = (file) => {
    const files = deletedFiles

    files.push(file)
    const tempOnlineVideos = onlineVideos.filter((i) => i.originalName !== file.originalName)
    setOnlineVideos(tempOnlineVideos)
  }

  const removeAsset = (file, type) => {
    const files = deletedFiles
    const secondsDeleted = deletedSeconds
    switch (type) {
      case 'image':
        if (!file.isNew) {
          files.push(file.fileName)
          setDeletedFiles(files)
        }
        const tempImages = images.filter((i) => i.fileName !== file.fileName)
        setImages(tempImages)
        break
      case 'video':
        if (!file.isNew) {
          files.push(file.fileName)
          secondsDeleted.push(file.secondsDuration ? file.secondsDuration : 0)
          setDeletedFiles(files)
          setDeletedSeconds(secondsDeleted)
        }
        const tempVideos = videos.filter((i) => i.fileName !== file.fileName)
        setVideos(tempVideos)
        break
      default:
        break
    }
  }

  const updateAsset = (file) => {
    let temp = tempUpdatedFiles
    if (tempUpdatedFiles.filter((el) => el.fileName === file.fileName).length > 0) {
      temp.filter((el) => el.fileName === file.fileName)[0].caption = file.caption
    } else {
      temp.push({ caption: file.caption, fileName: file.fileName })
    }
    setTempUpdatedFiles(temp)
  }

  const discardChanges = () => {
    setDialog({ open: false })
    setWelcomeEntity(cloneDeep(welcomeMessageDiscardEntity))
    setImages(cloneDeep(welcomeMessageDiscardEntity.images))
    setVideos(cloneDeep(welcomeMessageDiscardEntity.videos))
    setOnlineVideos(cloneDeep(welcomeMessageDiscardEntity.onlineVideos))
    setDeletedFiles([])
    setIsDiscardedMedia((prev) => !prev)
    setDiscarded((prevState) => !prevState)
    setTempUpdatedFiles([])
  }

  const cancelDialog = () => {
    setDialog({ open: false })
    setDiscarded(false)
  }
  const openConfirmationDialog = () => {
    setDialog({ open: true })
    setDiscarded(false)
  }

  //method to used for new video process encoding
  const saveSectionVideoProcess = async (type) => {
    closePreviewDialog()
    setDataPosted({ ...dataPosted, posted: false })
    setDisabledButton(true)
    setPosting(true)
    //check if save it is possible
    let readyToSave = isReadyToSave()
    if (!readyToSave) {
      setErrorLabel('Missing Information')
      errorSnackBarActions.setOpen(true, errorLabel)
      setDisabledButton(false)
      setPosting(false)
      return
    }

    let online = onLineVideoPayloadArray()
    let vid = videoPayloadArray()
    let img = imagePayloadArray()

    //encoding process PAYLOAD
    const jsonData = setNewEncodingPayload(img, vid.length, online, type)

    await WelcomeActions.getWelcomeMessageEmitStart(fireDepartment)
    const response = await CMSActions.saveSectionVideoProcess(jsonData)
    if (response === 'error') {
      errorSnackBarActions.setOpen(true)
      setDisabledButton(false)
      setPosting(false)
      return
    }

    //encoding method
    const promises = vid.map(async (v) => {
      const payload = {
        sectionVideoId: response._id,
        originalName: v.originalName,
        caption: v.caption,
        fullusername: iarMember.fullName,
        secondsDuration: v.secondsDuration,
        fireDepartmentId: fireDepartment.fireDepartmentId,
        timezone: fireDepartment.timezone
      }
      const responseEncoder = await CMSActions.sendToEncoderVideo(
        fireDepartment.identifier,
        v,
        payload
      )

      return {
        originalName: v.originalName,
        success: Boolean(responseEncoder)
      }
    })

    const results = await Promise.all(promises)
    const errors = results.filter((x) => !x.success)

    if (errors.length) {
      setErrorLabel('Was an error uploading this files: ', errors.join(','))
      errorSnackBarActions.setOpen(true, errorLabel)
      setDisabledButton(false)
      setPosting(false)
    }
  }

  const isReadyToSave = () => {
    let readyToSave = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let richText = bodyText || welcomeMessageEntity.bodyText

    if (!richText || EmptyTagsTypes.EmptyTag.includes(richText)) {
      setErrorBodyText('This field is required!')
      setDisabledButton(false)
      setPosting(false)
      setTimeout(() => {
        setErrorBodyText('')
      }, 5000)
      readyToSave = false
    }

    if (
      !welcomeMessageEntity.title ||
      EmptyTagsTypes.EmptyTag.includes(welcomeMessageEntity.title)
    ) {
      setErrorTitle('This field is required!')
      setDisabledButton(false)
      setPosting(false)
      setTimeout(() => {
        setErrorTitle('')
      }, 5000)
      readyToSave = false
    }

    return readyToSave
  }
  const switchContent = () => {
    if (!showPublishedContent) {
      previewedContentRef.current = {
        ...welcomeMessageEntity,
        videos,
        images,
        onlineVideos,
        bodyText
      }
    }
    setShowPublishedContent((prev) => !prev)
    setDiscarded((prevState) => !prevState)
    setDisabledButton((prevState) => !prevState)
  }

  const openPreviewDialog = () => {
    setIsPreviewDialogOpen(true)
  }

  const closeNotSavedPreviewDialog = () => {
    setIsPreviewNotSavedDialogOpen(false)
  }

  const closePreviewDialog = () => {
    setIsPreviewDialogOpen(false)
  }

  const openNotSavedPreviewDialog = () => {
    setIsPreviewNotSavedDialogOpen(true)
  }

  const openSaveDialog = () => {
    setIsSaveDialogOpen(true)
  }

  const closeSaveDialog = () => {
    setIsSaveDialogOpen(false)
  }

  const closeDiscardDialog = () => {
    setIsDiscardDialogOpen(false)
  }

  const openDiscardDialog = () => {
    setIsDiscardDialogOpen(true)
  }

  const publishButtonValidations = () => {
    if (
      bodyText !== welcomeMessageEntity.bodyText ||
      JSON.stringify(welcomeMessageEntity) !== JSON.stringify(welcomeMessageDiscardEntity) ||
      JSON.stringify(videos) !== JSON.stringify(welcomeMessageEntity.videos) ||
      JSON.stringify(images) !== JSON.stringify(welcomeMessageEntity.images) ||
      JSON.stringify(onlineVideos) !== JSON.stringify(welcomeMessageEntity.onlineVideos)
    ) {
      openNotSavedPreviewDialog()
    } else {
      openSaveDialog()
    }
  }

  return (
    <div className="App welcome-message" ref={wrapper}>
      <IARDialog
        open={isPreviewNotSaveDialogOpen}
        title="Save Preview first"
        content="Please save your changes in preview before publishing"
        onOk={closeNotSavedPreviewDialog}
        onCancel={closeNotSavedPreviewDialog}
        previewNotSaved={true}
      />
      <div className="page-header" id="homeTitle">
        Menu Section - Home
      </div>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <IARDialog
            open={dialog.open}
            title="Confirm"
            content="Do you want to discard your changes?"
            onOk={discardChanges}
            onCancel={cancelDialog}
          />
          <Container maxWidth="lg">
            <Grid container spacing={2}>
              <Grid size={12}>
                <div className="page-description">
                  This is the first page your community will see. What do you want to call this, and
                  what do you want to say? The page could be titled “Welcome”, “Message from the
                  Chief”, “Our History”, “Who We Are” or anything of your choosing. Include a
                  compelling message with reasons for them to come back again and again!
                </div>
              </Grid>
              <Grid size={12}>
                <form className="page-content" noValidate autoComplete="off">
                  <Grid container>
                    <Grid size={5} className="container-field">
                      <div>
                        {appConfiguration.previewEnabled && (
                          <>
                            <span>Display Content as PREVIEW MODE</span>
                            <CustomSwitch
                              name="showPublished"
                              value={!showPublishedContent}
                              sectionActiveChange={switchContent}
                              useYesNoButtons={true}
                            />
                          </>
                        )}
                      </div>
                    </Grid>
                    <PreviewContentLabel
                      showPublished={showPublishedContent}
                      previewEnabled={appConfiguration.previewEnabled}
                    />
                  </Grid>

                  <br />
                  <Grid size={12} className="container-field">
                    <label htmlFor="title">Title</label> <br />
                    <label htmlFor="error" className="error-text">
                      {errorTitle}
                    </label>
                    <CommunityTextField
                      className="title"
                      id="title"
                      name="title"
                      variant="outlined"
                      value={welcomeMessageEntity.title}
                      onChange={handleChange}
                      disabled={appConfiguration.previewEnabled && showPublishedContent}
                    />
                  </Grid>
                  <Grid size={12} className="container-field body-text">
                    <label htmlFor="message">Body text</label> <br />
                    <label htmlFor="error" className="error-text">
                      {errorBodyText}
                    </label>
                    <IARRte
                      onChange={rteChangeHandler}
                      content={welcomeMessageEntity.bodyText}
                      discarded={isDiscarded}
                      disableHandleChange={appConfiguration.previewEnabled && showPublishedContent}
                    />
                  </Grid>
                  <Grid size={12} className="container-field dropdown-container">
                    <div>
                      <label htmlFor="positionFiles">Position images and videos</label> <br />
                      <CustomDropdown
                        name="positionFiles"
                        value={welcomeMessageEntity.positionFiles || 0}
                        onChange={handleChange}
                        disableHandleChange={
                          appConfiguration.previewEnabled && showPublishedContent
                        }
                      />
                    </div>
                  </Grid>
                  <Grid container>
                    <Grid size={12}>
                      <Grid className="container-field">
                        <label htmlFor="images" className="body-text">
                          Media Files
                        </label>
                        <MediaFilesMessage max={5}></MediaFilesMessage>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid size={{ xs: 12, md: 6 }} className="media-files">
                      <div id="choose-img-div">
                        <ChooseImage
                          images={images}
                          setImages={setImages}
                          fireDepartmentIdentifier={welcomeMessageEntity.fireDepartmentIdentifier}
                          max={5}
                          elementsAdded={images.length + videos.length}
                          setErrorLabel={setErrorLabel}
                          isMessageEnabled={false}
                          disableHandleClick={
                            appConfiguration.previewEnabled && showPublishedContent
                          }
                        ></ChooseImage>
                      </div>
                      <>
                        {images.map((image, index) => {
                          return (
                            <MediaThumbnail
                              isDiscardedMedia={isDiscardedMedia}
                              type="image"
                              key={[image.fileName, image.caption, index].join('-')}
                              media={image}
                              removeMediaEvent={removeAsset}
                              onUpdate={updateAsset}
                              disableHandleClick={
                                appConfiguration.previewEnabled && showPublishedContent
                              }
                            />
                          )
                        })}
                      </>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} className="media-files">
                      <ChooseVideo
                        videos={videos}
                        setVideos={setVideos}
                        fireDepartmentIdentifier={welcomeMessageEntity.fireDepartmentIdentifier}
                        max={5}
                        elementsAdded={images.length + videos.length}
                        setErrorLabel={setErrorLabel}
                        isMessageEnabled={false}
                        disableHandleClick={appConfiguration.previewEnabled && showPublishedContent}
                      ></ChooseVideo>
                      <>
                        {videos.map((video, index) => {
                          return (
                            <MediaThumbnail
                              isDiscardedMedia={isDiscardedMedia}
                              type="video"
                              key={[video.fileName, video.caption, index].join('-')}
                              media={video}
                              removeMediaEvent={removeAsset}
                              index={index}
                              onUpdate={updateAsset}
                              disableHandleClick={
                                appConfiguration.previewEnabled && showPublishedContent
                              }
                            />
                          )
                        })}
                      </>
                    </Grid>
                    <Grid size={12} className="media-files">
                      <OnlineVideos
                        videos={onlineVideos}
                        setOnlineVideos={setOnlineVideos}
                        setErrorLabel={setErrorLabel}
                        max={5}
                        disableHandleClick={appConfiguration.previewEnabled && showPublishedContent}
                      />
                      {onlineVideos?.map((onlineVideo, index) => (
                        <MediaThumbnail
                          isDiscardedMedia={isDiscardedMedia}
                          type="online"
                          key={[onlineVideo.fileName, onlineVideo.caption, index].join('-')}
                          media={onlineVideo}
                          removeMediaEvent={removeAsset}
                          index={index}
                          subType={videoTypes.YoutubeVideos}
                          onUpdate={updateAsset}
                          removeOnlineVideo={removeOnlineVideo}
                          disableHandleClick={
                            appConfiguration.previewEnabled && showPublishedContent
                          }
                        />
                      ))}
                    </Grid>
                  </Grid>

                  <Grid size={12} className="container container-buttons">
                    {appConfiguration?.previewEnabled ? (
                      <PrepublishButtons
                        isDiscardDialogOpen={isDiscardDialogOpen}
                        isPreviewDialogOpen={isPreviewDialogOpen}
                        isReadOnlyMember={isReadOnlyMember}
                        isShown={appConfiguration.previewEnabled}
                        isSaveDialogOpen={isSaveDialogOpen}
                        openPreviewDialog={openPreviewDialog}
                        openDiscardDialog={openDiscardDialog}
                        closePreviewDialog={closePreviewDialog}
                        closeDiscardDialog={closeDiscardDialog}
                        closeSaveDialog={closeSaveDialog}
                        discardChanges={discardChanges}
                        disabledButton={disabledButton}
                        publishButtonValidations={publishButtonValidations}
                        posting={posting}
                        savePreview={
                          withNewEncodingProcess
                            ? () =>
                                saveSectionVideoProcess(EncondingSectionType.WelcomeMessagePreview)
                            : sendWelcomeMessagePreview
                        }
                        savePublish={publishPost}
                      />
                    ) : (
                      <div className="save-button-container">
                        <ButtonSave
                          id="saveButton"
                          disabled={isReadOnlyMember || disabledButton}
                          loading={posting}
                          onClickCallback={
                            withNewEncodingProcess
                              ? () => saveSectionVideoProcess(EncondingSectionType.WelcomeMessage)
                              : sendWelcomeMessage
                          }
                        />
                        <Button
                          style={{ maxWidth: '250px', minWidth: '250px' }}
                          disabled={isReadOnlyMember || disabledButton}
                          variant="outlined"
                          id="cancelButtonEntity"
                          color="primary"
                          size="medium"
                          onClick={openConfirmationDialog}
                        >
                          Discard
                        </Button>
                        <div>{renderSavedMessage()}</div>
                      </div>
                    )}
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </div>
  )
}

export default WelcomeMessage
